import "./HeadingComponent.scss";
import React from "react";

interface HeadingComponentProps {
    showDummyGap?: boolean;
}

const HeadingComponent = (props: React.PropsWithChildren<HeadingComponentProps>) => {
    const {children, showDummyGap = false} = props;

    return (
        <h2 className="text-3xl md:text-4xl font-medium mb-9 text-center flex items-start max-w-xl gap-3.75 text-secondary">
            {showDummyGap && <div className="w-1 h-10 bg-gradient-to-r from-primary to-secondary joy-avatar-hidden"></div>}
            <div>
                {children}
            </div>
        </h2>
    );

};

export default HeadingComponent;
